import log2 from "../js/log2-lite";

const log = log2("SUPSIS_SDK");
const isLoaded = () => {
    return !!(window.supsis && window.supsis.i && window.supsis.i.connected);
};
export const onLoaded = () =>
    isLoaded()
        ? Promise.resolve(window.supsis.i)
        : new Promise((resolve) => {
              window.addEventListener(
                  "supsis-loaded",
                  function (e) {
                      resolve(window.supsis.i);
                  },
                  false
              );
          });

export const onMinimized = () =>
    new Promise((resolve) => {
        window.addEventListener(
            "supsis-minimized",
            function (e) {
                resolve(window.supsis.i);
            },
            false
        );
    });

export const onTabVisible = () =>
    document.visibilityState === "visible"
        ? Promise.resolve(true)
        : new Promise((resolve) => {
              document.addEventListener("visibilitychange", visibilityHandler);

              function visibilityHandler() {
                  if (document.visibilityState === "visible") {
                      document.removeEventListener("visibilitychange", visibilityHandler);
                      resolve(true);
                  }
              }
          });

const COMMANDS = {
    MINIMIZE: "minimize",
    CHANGE_DEPARTMENT: "department",
    MAXIMIZE: "open",
    SET_USER_DATA: "setUserData",
    READY_EVENT: "ready",
    MINIMIZE_EVENT: "onMinimized",
    LOGIN: "login",
    DESTROY: "destroy",
    ASK: "ask",
    SET_CHATBOT_START_BLOCK_ID: "setChatbotStartBlockId",
    CLOSE_CHAT: "closeChat",
    SET_CONTACT_PROPERTY: "setContactProperty",
    HIDE: "hide",
    CLEAR_CACHE: "clearCache",
    SET_VIP_CUSTOMER: "setVipCustomer",
    SET_WINDOW_SIZE: "setWindowSize",
};
const handleCommand = (cmd, payload) => {
    const ls = window.supsis.i;
    log("handleCommand", { cmd, payload, ls });
    if (cmd === COMMANDS.MINIMIZE) {
        ls.minimizeButton.click();
    } else if (cmd === COMMANDS.MAXIMIZE || cmd === "maximize") {
        document.body.classList.remove("ls-hide");
        ls.openOptions = payload;
        ls.openButton.click();
        if (ls.fabContainer) {
            ls.fabContainer.style.display = "none";
        }
    } else if (cmd === COMMANDS.ASK) {
        ls.askDialog(payload);
    } else if (cmd === COMMANDS.SET_USER_DATA) {
        onLoaded().then((ls) => {
            log("SDK:SET_USER_DATA sending to iframe", payload);
            ls.iframe.contentWindow.postMessage(
                {
                    command: "set-user-data",
                    payload,
                },
                "*"
            );
        });
    } else if (cmd === COMMANDS.LOGIN) {
        onLoaded().then((ls) => {
            log("SDK:LOGIN sending to iframe", payload);
            ls.iframe.contentWindow.postMessage(
                {
                    command: "auto-login",
                    payload,
                },
                "*"
            );
        });
    } else if (cmd === COMMANDS.CHANGE_DEPARTMENT) {
        onLoaded().then((ls) => {
            log("SDK:CHANGE_DEPARTMENT sending to iframe", payload);
            for (let i = 0; i < 100; i++) {}
            ls.iframe.contentWindow.postMessage(
                {
                    command: "set-department",
                    payload,
                },
                "*"
            );
        });
    } else if (cmd === COMMANDS.SET_CHATBOT_START_BLOCK_ID) {
        onLoaded().then((ls) => {
            log("SDK:SET_CHATBOT_START_BLOCK_ID sending to iframe", payload);
            ls.iframe.contentWindow.postMessage(
                {
                    command: "set-chatbot-start-block-id",
                    payload,
                },
                "*"
            );
        });
    } else if (cmd === COMMANDS.READY_EVENT) {
        const cb = payload;
        onLoaded().then(() => {
            cb(window.supsis);
        });
    } else if (cmd === COMMANDS.CLOSE_CHAT) {
        ls.iframe.contentWindow.postMessage(
            {
                command: "close-chat",
                payload,
            },
            "*"
        );
    } else if (cmd === COMMANDS.MINIMIZE_EVENT) {
        const cb = payload;
        onMinimized().then(() => {
            cb(window.supsis);
        });
    } else if (cmd === COMMANDS.DESTROY) {
        let selectors = ["#previewScript", "#ls-openButton", "#ls-trigger", "#ls-container", "#supsis-actions"];
        selectors.forEach((selector) => {
            let elements = document.querySelectorAll(selector);
            elements.forEach((element) => element.parentNode.removeChild(element));
        });
        window.supsis = undefined;
        window.supsisLoadingStarted = undefined;
    } else if (cmd === COMMANDS.SET_CONTACT_PROPERTY) {
        onLoaded().then((ls) => {
            log("SDK:SET_CONTACT_PROPERTY sending to iframe", payload);
            ls.iframe.contentWindow.postMessage(
                {
                    command: "set-contact-property",
                    payload,
                },
                "*"
            );
        });
    } else if (cmd === COMMANDS.HIDE) {
        document.body.classList.add("ls-hide");
    } else if (cmd === COMMANDS.CLEAR_CACHE) {
        onLoaded().then((ls) => {
            log("SDK:LOGIN sending to iframe", payload);
            ls.iframe.contentWindow.postMessage(
                {
                    command: "clear-cache",
                    payload: {},
                },
                "*"
            );
        });
    } else if (cmd === COMMANDS.SET_VIP_CUSTOMER) {
        ls.iframe.contentWindow.postMessage(
            {
                command: "set-vip-customer",
                payload: {
                    isVipCustomer: payload,
                },
            },
            "*"
        );
    } else if (cmd === COMMANDS.SET_WINDOW_SIZE) {
        log("SDK:SET_WINDOW_SIZE", payload);
        const mode = payload;
        if (mode === "videocall") {
            window.supsis.i.container.classList.add("videocall");
        } else if (mode === "large") {
            window.supsis.i.container.classList.add("supsis-large-mode");
        } else {
            window.supsis.i.container.classList.remove("videocall");
            window.supsis.i.container.classList.remove("supsis-large-mode");
        }
    } else {
        log.error("unhandled message received", cmd);
    }
};

let preJobs = [];

const isInitialized = () => {
    return typeof window.supsis === "function" && window.supsis.loaded;
};
export const isInitializedBefore = isInitialized();
const SDK = function (cmd, payload) {
    handleCommand(cmd, payload);
};

const initializeSDK = () => {
    if (!isInitializedBefore) {
        SDK.minimize = () => {
            handleCommand(COMMANDS.MINIMIZE, {});
        };
        SDK.open = (payload) => {
            handleCommand(COMMANDS.MAXIMIZE, payload);
            document.body.classList.remove("ls-hide");
        };
        SDK.hide = () => {
            handleCommand(COMMANDS.HIDE, {});
        };
        SDK.ask = (payload) => {
            handleCommand(COMMANDS.ASK, payload);
        };
        SDK.login = (payload) => {
            handleCommand(COMMANDS.LOGIN, payload);
        };
        SDK.ready = (cb) => {
            handleCommand(COMMANDS.READY_EVENT, cb);
        };
        SDK.setUserData = (userData) => {
            handleCommand(COMMANDS.SET_USER_DATA, userData);
        };
        SDK.setContactProperty = (data) => {
            handleCommand(COMMANDS.SET_CONTACT_PROPERTY, data);
        };
        SDK.changeDepartment = (department) => {
            handleCommand(COMMANDS.CHANGE_DEPARTMENT, department);
        };
        SDK.clearCache = () => {
            handleCommand(COMMANDS.CLEAR_CACHE, {});
        };
        SDK.closeChat = () => {
            handleCommand(COMMANDS.CLOSE_CHAT, {});
        };
        SDK.setVipCustomer = (vipCustomer) => {
            handleCommand(COMMANDS.SET_VIP_CUSTOMER, vipCustomer);
        };
        SDK.setWindowSize = (mode) => {
            handleCommand(COMMANDS.SET_WINDOW_SIZE, mode);
        };
        SDK.maximize = SDK.open;
        return true;
    } else {
        return false;
    }
};

onLoaded().then((ls) => {
    log.info("pre defined commands running", preJobs);
    preJobs.forEach((x) => handleCommand(x[0], x[1]));
});

(() => {
    if (window.supsisLoadingStarted) {
        log.error("supsis initialized before");
        return;
    }
    if (!initializeSDK()) {
        log.error("supsis sdk initialized before");
        return;
    }
    if (typeof window.supsis === "function" && Array.isArray(window.supsis.q)) {
        preJobs = window.supsis.q;
        SDK.q = window.supsis.q;
        SDK.l = window.supsis.l;
        if (window.supsis.i) SDK.i = window.supsis.i;
        SDK.loaded = true;
    }

    window.supsis = SDK;
})();



//////////////////
// WEBPACK FOOTER
// ./static/src/sdk.js
// module id = Y9DH
// module chunks = 1